const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const splitDate = (text = "") => {
  const [day = "", month = "", year = ""] = String(text).split("/");
  return {
    day: day.replace(/\D/g, "").slice(0, 2).padStart(2, "0"),
    month: month.replace(/\D/g, "").slice(0, 2).padStart(2, "0"),
    year: year.replace(/\D/g, "").slice(0, 4),
  };
};

const fmtQty = (value) => {
  const num = Number(value || 0);
  if (!Number.isFinite(num)) return "";
  if (Math.abs(num - Math.trunc(num)) < 0.000001) return `${Math.trunc(num)}`;
  return num.toFixed(3).replace(/\.0+$/, "").replace(/(\.\d*?)0+$/, "$1");
};

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

export const getPrintTemplate = ({ headerInfo, rows, totalAmount }) => {
  const date = splitDate(headerInfo.documentDate);

  const rowsHtml = (rows || [])
    .map(
      (row, index) => `
      <tr>
        <td class="center">${index + 1}</td>
        <td>${escapeHtml(row.itemName || "")}</td>
        <td>${escapeHtml(row.purchaseAddress || "")}</td>
        <td class="center">${escapeHtml(row.unit || "")}</td>
        <td class="right">${fmtQty(row.quantity)}</td>
        <td class="right">${fmtMoney(row.unitPrice)}</td>
        <td class="right">${fmtMoney(row.amount)}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Bảng Kê Mua Hàng</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 15px; color:#000; margin: 0; padding: 12px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.4; }
        .right { text-align:center; line-height:1.35; }
        .title { text-align:center; margin-top:12px; font-size:29px; font-weight:700; text-transform:uppercase; }
        .date-line { text-align:center; margin-top:8px; font-style:italic; }
        .meta-right { text-align:right; margin-top:6px; line-height:1.6; }
        table { width:100%; border-collapse:collapse; margin-top:10px; font-size:14px; }
        th, td { border:1px solid #000; padding:4px; vertical-align:middle; }
        th { text-align:center; font-weight:700; }
        .center { text-align:center; }
        .right { text-align:right; }
        .signatures { margin-top:22px; display:flex; justify-content:space-between; text-align:center; }
        .sign-col { width:33%; }
        .sign-spacer { height: 16px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="left">
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(headerInfo.department || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số: 06 - VT</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">BẢNG KÊ MUA HÀNG</div>
      <div class="date-line">Ngày ${date.day || "..."} tháng ${date.month || "..."} năm ${date.year || "...."}</div>

      <div class="meta-right">
        <div>Quyển số: ${escapeHtml(headerInfo.bookNumber || "")}</div>
        <div>Số: ${escapeHtml(headerInfo.documentNumber || "")}</div>
        <div>Nợ: ${escapeHtml(headerInfo.debitAccount || "")}</div>
        <div>Có: ${escapeHtml(headerInfo.creditAccount || "")}</div>
      </div>

      <div style="margin-top:6px;">- Họ và tên người mua: ${escapeHtml(headerInfo.buyerName || "")}</div>
      <div style="margin-top:4px;">- Bộ phận (phòng, ban): ${escapeHtml(headerInfo.buyerDepartment || "")}</div>

      <table>
        <thead>
          <tr>
            <th style="width:6%">STT</th>
            <th style="width:34%">Tên, quy cách, phẩm chất hàng hóa (vật tư, công cụ...)</th>
            <th style="width:20%">Địa chỉ mua hàng</th>
            <th style="width:10%">Đơn vị tính</th>
            <th style="width:10%">Số lượng</th>
            <th style="width:10%">Đơn giá</th>
            <th style="width:10%">Thành tiền</th>
          </tr>
          <tr>
            <th>A</th><th>B</th><th>C</th><th>D</th><th>1</th><th>2</th><th>3</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td colspan="6" class="center"><b>Cộng</b></td>
            <td class="right"><b>${fmtMoney(totalAmount)}</b></td>
          </tr>
        </tbody>
      </table>

      <div class="signatures">
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Người mua hàng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Kế toán trưởng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div><i>Ngày... tháng... năm...</i></div>
          <div><b>Giám đốc</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
